<template lang="pug">
  p.multiple-rows__n-a(v-if="isEmpty(value)") not available
  .multiple-rows-wrapper(v-else)
    template(v-if="value && isPeriod")
      periods-table-block(:periods="value" :disableField="disableField" :prerequisite="prerequisite")

    template(v-else)
      table-row(
        v-for='(item, i) of value'
        :insideMultipleRow='true'
        :item="item"
        :key="i")

</template>

<script>
export default {
  name: 'MultipleRows',
  components: {
    PeriodsTableBlock: () => import('@/components/record-details/periods/PeriodsTableBlock'),
    TableRow: () => import('@/components/record-details/table-components/TableRow'),
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      type: [ Object, Array, String, ],
      default: null,
    },
  },
  computed: {
    isPeriod () {
      return this.item.isPeriod
    },
    prerequisite () {
      return this.item.prerequisite
    },
    disableField () {
      return this.item.disableField
    },
  },
  methods: {
    isEmpty (value) {
      return !value || value === '' || (Array.isArray(value) && value.length === 0)
    },
  },
}
</script>

<style scoped lang="stylus">
@import "../../../assets/styles/variables.styl"

  .multiple-rows__n-a
    padding: 15px 20px
    @media (max-width: $tablet)
      padding 0


  .multiple-rows-wrapper
    background-color: transparent
</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/MultipleRows.vue